import * as log from "loglevel";

log.setLevel(process.env.NODE_ENV === "production" ? log.levels.WARN : log.levels.TRACE);
